import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-charcoal" data-id="element-90" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-91" data-mp="9tbemxtmiqit">
        <p className="font-display text-xs font-bold uppercase tracking-widest text-wood" data-id="element-92" data-mp="et66p4p4xm5g">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border-2 border-wood bg-cream-light p-3 text-left" data-id="element-93" data-mp="jrr6x44e05tw">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-wood" data-id="element-94" data-mp="nsb5mc4lzhi5">
            <ShieldCheckIcon size={20} className="text-white" data-id="element-95" data-mp="smxdw6fe8ty0" />
          </span>
          <div data-id="element-96" data-mp="xjfjf8ijswbe">
            <h2 id="garantia" className="font-display text-sm font-extrabold uppercase leading-tight sm:text-base" data-id="element-97" data-mp="xm1mauuhunna">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-charcoal/80 sm:text-sm" data-id="element-98" data-mp="25rx8om5t6ryg">
              Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si
              considerás que el sistema no es adecuado para vos, podés
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}